//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        /** @type {import('vue').PropOptions<Record<string, string> | ((key: string) => string)>} */
        translations: {
            type: [Object, Function],
            required: true,
        },
    },
    data() {
        return {
            showBanner: false,
            hiddenBanner: false,
            fallback: {
                policyDesktop: 'By closing this message, you consent to TIDAL\'s use of cookies on this device in accordance with its <a href="https://tidal.com/privacy" target="_blank">cookies policy</a>, unless you have disabled them through your browser settings.',
                policyMobile: 'By closing this message, you consent to TIDAL\'s use of cookies on this device in accordance with our <a href="https://tidal.com/privacy" target="_blank">cookies policy</a>.',
            },
        };
    },
    computed: {
        /** @return {string} */
        desktopText() {
            return this.stringForKey('policyDesktop');
        },
        /** @return {string} */
        mobileText() {
            return this.stringForKey('policyMobile');
        },
    },
    mounted() {
        if (document.cookie.indexOf('tidal-cookie-policy-v2') >= 0) {
            this.showBanner = false;
            this.$emit('hidden', true);
        } else {
            this.showBanner = true;
        }
    },
    methods: {
        /**
         * @param {'policyDesktop' | 'policyMobile'} key
         * @return {string}
         */
        stringForKey(key) {
            let text;

            if (typeof this.translations === 'function') {
                text = this.translations(key);
            } else {
                text = this.translations[key];
            }

            if (!text) {
                text = this.fallback[key];
            }

            return text;
        },
        hideCookie() {
            this.hiddenBanner = true;
            const domain = `${location.hostname.endsWith('dev.tidal.com') ? 'dev.' : ''}tidal.com`;
            const options = location.protocol === 'https' ? 'SameSite=None; Secure' : '';
            document.cookie = `tidal-cookie-policy-v2=true; domain=${domain}; path=/; max-age=15780000; ${options}`;
            this.$emit('hidden', true);
        },
    },
};
